<a
  [routerLink]="navigationItem.route"
  [routerLinkActiveOptions]="{ exact: true }"
  routerLinkActive="active"
  class="link"
  [class.highlighted]="navigationItem.highlighted"
  [class.trimmed]="isTrimmed"
  [class.highlightText]="navigationItem.highlightText"
>
  <app-icon class="link-icon" [icon]="navigationItem.icon" [hasHoverState]="navigationItem.hasHoverState" [isHovered]="isHovered" [width]="20" />
  <span class="link-title">
    {{ navigationItem.title }}
  </span>
  @if (navigationItem.value) {
  <span class="link-badge badge badge_red badge_rounded badge_font-l">{{ navigationItem.value }}</span>
  } @else if (navigationItem.dot) {
  <span class="link-dot"></span>
  }
</a>

@if (isTrimmed) {
<div class="tooltip">
  <svg class="tooltip-arrow" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 0V14L0 7L8 0Z" fill="#131313" />
  </svg>
  <span class="tooltip-title">
    {{ navigationItem.title }}
  </span>
</div>
}
